// extracted by mini-css-extract-plugin
export default {"inputs":"Form_inputs__0lWiC","bottomInputs":"Form_bottomInputs__dtGHb"};